"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlamingoSwapHelper = void 0;
const neon_core_1 = require("@cityofzion/neon-core");
const bignumber_js_1 = __importDefault(require("bignumber.js"));
const FlamingoSwapConstants_1 = require("../constants/FlamingoSwapConstants");
const handlers_1 = require("../services/swap/handlers");
class FlamingoSwapHelper {
    static listSwappableTokensSymbol(network) {
        return Object.keys(handlers_1.FlamingoSwapRouteHandler.createPoolGraph(network));
    }
    static getFlamingoSwapPools(network) {
        const pools = FlamingoSwapConstants_1.FlamingoSwapConstants.FLAMINGO_SWAP_POOLS[network.id];
        if (!pools) {
            throw new Error('Invalid network');
        }
        return pools;
    }
    static getFlamingoSwapPool(network, name) {
        const pools = this.getFlamingoSwapPools(network);
        const pool = pools[name];
        if (!pool) {
            throw new Error('Invalid pool');
        }
        return pool;
    }
    static getFlamingoSwapTokens(network) {
        const tokens = FlamingoSwapConstants_1.FlamingoSwapConstants.FLAMINGO_SWAP_TOKENS[network.id];
        if (!tokens) {
            throw new Error('Invalid network');
        }
        return tokens;
    }
    static getFlamingoSwapToken(network, name) {
        const tokens = this.getFlamingoSwapTokens(network);
        const token = tokens[name];
        if (!token) {
            throw new Error('Invalid token');
        }
        return token;
    }
    static getFlamingoSwapScriptHashes(network) {
        const swapScriptHashes = FlamingoSwapConstants_1.FlamingoSwapConstants.FLAMINGO_SWAP_SCRIPT_HASHES[network.id];
        if (!swapScriptHashes) {
            throw new Error('Invalid network');
        }
        return swapScriptHashes;
    }
    static getRoutePath(route) {
        return route
            .flatMap(item => [item.tokenToUse, item.tokenToReceive])
            .filter((item, index, arr) => arr.indexOf(item) === index);
    }
    static overrideToken(network, token) {
        return this.isNeoToken(network, token) ? this.getFlamingoSwapToken(network, 'bNEO') : token;
    }
    static overrideAmountInput(network, amount, token) {
        const overrodeToken = this.overrideToken(network, token);
        return new bignumber_js_1.default(amount).shiftedBy(overrodeToken.decimals);
    }
    static overrideAmountToDisplay(network, amount, token) {
        const overrodeToken = this.overrideToken(network, token);
        return new bignumber_js_1.default(amount).shiftedBy(-overrodeToken.decimals).toFixed();
    }
    static overrideRoute(network, route) {
        const overrodeRoute = [];
        for (const routeItem of route) {
            if (!this.isNeoToken(network, routeItem.tokenToUse) && !this.isNeoToken(network, routeItem.tokenToReceive)) {
                overrodeRoute.push(routeItem);
            }
        }
        return overrodeRoute;
    }
    static overrideRoutePath(network, routePath) {
        const overrodeRoutePath = routePath.map(token => this.overrideToken(network, token));
        return overrodeRoutePath.filter((item, index, arr) => arr.indexOf(item) === index);
    }
    static normalizeHash(hash) {
        return hash.startsWith('0x') ? hash.slice(2) : hash;
    }
    static isNeoToken(network, token) {
        const NEO = this.getFlamingoSwapToken(network, 'NEO');
        return this.normalizeHash(token.hash) === this.normalizeHash(NEO.hash);
    }
    static isBneoToken(network, token) {
        const bNEO = this.getFlamingoSwapToken(network, 'bNEO');
        return this.normalizeHash(token.hash) === this.normalizeHash(bNEO.hash);
    }
    static formatAmount(amount, decimals) {
        return neon_core_1.u.BigInteger.fromDecimal(Number(amount), decimals).toString();
    }
    static isSwapUnwrappingNeo(network, route) {
        if (route.length < 3) {
            return false;
        }
        const lastToken = route[route.length - 1];
        return this.isNeoToken(network, lastToken);
    }
    static isSwapWrappingNeo(network, route) {
        if (route.length < 3) {
            return false;
        }
        const firstToken = route[0];
        return this.isNeoToken(network, firstToken);
    }
    static isWrapNeo(network, route) {
        if (route.length !== 2) {
            return false;
        }
        const firstToken = route[0];
        const lastToken = route[1];
        return this.isNeoToken(network, firstToken) && this.isBneoToken(network, lastToken);
    }
    static isUnwrapNeo(network, route) {
        if (route.length !== 2) {
            return false;
        }
        const firstToken = route[0];
        const lastToken = route[1];
        return this.isBneoToken(network, firstToken) && this.isNeoToken(network, lastToken);
    }
    static getUnwrappedAmount(amount) {
        return neon_core_1.u.BigInteger.fromNumber(Number(amount) * FlamingoSwapConstants_1.FlamingoSwapConstants.UNWRAPPING_FEE).toString();
    }
}
exports.FlamingoSwapHelper = FlamingoSwapHelper;
